import React from "react";
import Modal from "../Modal";
import SearchableDropdown from "../SearchableDropdown";
import Button from "../Button";
import { Colors } from "../../config/Constants";

const MembershipPaymentModal = ({
  setMembershipPaymentModal,
  handleContinue,
  onSearchChange,
  searchText,
  expiryList,
  onExpiryItemSelect,
  selectedExpiredItem,
}) => {
  return (
    <Modal
      variant={"none"}
      setOpenOrClose={() => setMembershipPaymentModal(false)}
      width={"350px"}
    >
      <div
        style={{
          padding: "1rem",
          display: "flex",
          gap: "1rem",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div />
          <div>Membership Payment</div>
          <img
            onClick={() => setMembershipPaymentModal(false)}
            style={{ width: "1rem", height: "1rem" }}
            src={require("../../assets/images/close.png")}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div style={{ fontSize: "14px", textAlign: "center" }}>
            Please provide the email address of the individuals to whom you
            would like to send the payment link for membership.
          </div>
          <div>
            <SearchableDropdown
              label="Select Member to send Payment Link"
              required
              placeholder="Select"
              onSearchChange={onSearchChange}
              searchText={searchText}
              expiryList={expiryList}
              onExpiryItemSelect={onExpiryItemSelect}
              selectedExpiredItem={selectedExpiredItem}
            />
          </div>
          <Button
            disabled={!selectedExpiredItem?.name}
            isRounded
            variant="filled"
            fontColor={Colors.white}
            color={Colors.red}
            label="Continue"
            onClick={() =>
              handleContinue({
                ...selectedExpiredItem,
                id: selectedExpiredItem.membershipId,
              })
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default MembershipPaymentModal;
